/* This file was generated automatically. Do not edit manually. */

export enum AssistantSearchType {
    AvailabilityBlock = 'AvailabilityBlock',
    Bill = 'Bill',
    City = 'City',
    Company = 'Company',
    Customer = 'Customer',
    EnterpriseProfile = 'EnterpriseProfile',
    Locations = 'Locations',
    Navigation = 'Navigation',
    ProductServiceOrder = 'ProductServiceOrder',
    Reservation = 'Reservation',
    ReservationGroup = 'ReservationGroup',
    Resource = 'Resource',
    ResourceBlock = 'ResourceBlock',
    TravelAgency = 'TravelAgency',
    Command = 'Command',
    RoutingRule = 'RoutingRule',
}
